import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 5v14M5 12h14", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round" }));
export default SvgPlus;
